import { Button, Card } from "react-bootstrap";
import { FaCheck } from "react-icons/fa6";

export default function PricingCard({props, activeTab}) {
  return (
    <Card className="pricing-card border-0 text-start mb-4 mb-md-0">
      {
        props?.popular === true && <span className="popular">Most Popular</span>
      }
      <Card.Header className="bg-transparent">
        <Card.Title className="fs-6 fw-semibold mb-2">{props?.title}</Card.Title>
        <p className="price">
          {activeTab === "monthly" ? props?.price_monthly === 0 ? "Free" : `$${props?.price_monthly}` : props?.price_annually === 0 ? "Free" : `$${props?.price_annually}`}
        </p>
        <p>{props?.description}</p>
        <Button variant="outline-secondary d-block w-100">{props?.btnLabel}</Button>
      </Card.Header>
      <Card.Body>
        <h6>FEATURES</h6>
        <p>{props?.features?.description}</p>
        <ul className="list-unstyled mb-0">
          {props?.features?.options?.map((point, index) => (
            <li key={index}><FaCheck /> <span className="ms-3">{point}</span></li>
          ))}
        </ul>
      </Card.Body>
    </Card>
  );
};